import styled from "styled-components";
import { useRef, type FunctionComponent, type ReactNode, } from "react";
import { Tooltip as ReactTooltip, type ITooltip } from "react-tooltip";
import { getTheme, themed, Box, Div, } from "@bracket/ui";
import { QuestionIcon } from "./QuestionIcon";



export declare type TooltipProps = {
	message: ReactNode;
	children?: ReactNode;
	position?: ITooltip["place"];
	marginLeft?: string;
};


export const Tooltip: FunctionComponent<TooltipProps> = ({
	message,
	position = "bottom",
	marginLeft,
	children,
}) => {
	themed();

	const tooltipId = useRef(`tooltip-${Math.random().toString(36).slice(2, 9)}`);

	return (
		<Brace style={{ marginLeft, marginRight: marginLeft ? "1rem" : undefined, }}>
			<TooltipWrapper data-tooltip-id={tooltipId.current}>
				{ children || <QuestionIcon /> }
			</TooltipWrapper>
			<ReactTooltip
				id={tooltipId.current}
				place={position}
				render={() => <span>{message}</span>}
				delayHide={100}
				delayShow={200}
				positionStrategy="fixed"
				style={{
					zIndex: 922299,
					backgroundColor: getTheme().surface,
					color: getTheme().surface_on,
					fontWeight: 400,
					maxWidth: "300px",
					borderRadius: "8px",
					fontFamily: getTheme().fonts.body,
					padding: "1rem",
					fontSize: "14px",
				}}
			/>
		</Brace>
	);
};

export default Tooltip;

const Brace = styled(Box)`
	position: relative;
	display: flex;
	.react-tooltip {
		opacity: 1;
		z-index:99999;
	}
`
const TooltipWrapper = styled(Div)`
	position: relative;
	display: inline-flex;
	cursor: pointer;
`;

// const StyledTooltip = styled(ReactTooltip)`
// 	&.react-tooltip {
// 		background: ${() => getTheme().background_on};
// 		color: ${() => getTheme().surface};
// 		padding: 0.5rem 0.75rem;
// 		border-radius: 0.375rem;
// 		font-size: 0.875rem;
// 		line-height: 1.25rem;
// 		max-width: 300px;
// 		white-space: pre-wrap;
// 		word-break: break-word;
// 		z-index: 99999;
// 		font-family: ${() => getTheme().fonts.body} !important;
// 		pointer-events: none;
// 		will-change: opacity;
// 		transform: translateZ(0);
// 		backface-visibility: hidden;
// 		transition: opacity 250ms ease-in-out;
// 		opacity: 1;
// 		visibility: visible;
// 	}

// 	&.react-tooltip[aria-hidden="true"] {
// 		opacity: 0;
// 		visibility: hidden;
// 		transition: opacity 250ms ease-in-out, visibility 0s linear 250ms;
// 	}

// 	&.react-tooltip[data-show] {
// 		opacity: 1 !important;
// 		visibility: visible !important;
// 		transition: opacity 250ms ease-in-out, visibility 0s linear 0s;
// 	}
// `;
